import { render, staticRenderFns } from "./SecuritySetup.vue?vue&type=template&id=1e29be03&scoped=true&"
import script from "./SecuritySetup.vue?vue&type=script&lang=js&"
export * from "./SecuritySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e29be03",
  null
  
)

export default component.exports